import cacheKeys from '@/data/api/cacheKeys';
import { getSellers } from '@/data/api/request/sellerRequests';
import { ONE_SECOND_MS } from '@/utils/time';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export function useGetSellers() {
  const [filter, setFilter] = useState<string>();

  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.product.catalogSeller, filter],
    queryFn: () => getSellers({ searchTerm: filter }),
    staleTime: 10 * ONE_SECOND_MS,
  });

  return {
    data,
    error,
    isLoading,
    setFilter,
  };
}
